export const ModeRemuneration = [
  'Mensuel',
  'Horaire',
] as const

export type ModeRemuneration = typeof ModeRemuneration[number]

export const ModeRemunerationLibelle: {
  [key in ModeRemuneration]: string
} = {
  Mensuel: 'Mensuel',
  Horaire: 'Horaire',
} as const
